<template>
  <div class="files column label wrap">
    <div v-if="modal.pendency && modal.pendency.subtipos_arquivo" class="row wrap">
      <label>Tipo de documento</label>
      <select class="input" v-model="modal.pendency.subtipo_arquivo" @change="updateSub()">
        <option v-for="subtipo in modal.pendency.subtipos_arquivo" :value="subtipo.identificador" :key="subtipo.nome">
          {{ subtipo.nome }}
        </option>
      </select>
      <div class="ilustration row column-s align-center" v-if="modal.pendency.subtipo_arquivo">
        <img v-if="modal.pendency.tipo_arquivo == '4_self_doutor_doc'" src="../../assets/img/idselfie.png" />
        <div v-if="modal.pendency.tipo_arquivo == '4_self_doutor_doc'">
          Envie uma foto de rosto segurando o documento de identidade enviado
          anteriormente com face da foto virada para frente.
        </div>

        <template v-else>
          <img v-if="modal.pendency.subtipo_arquivo == 'cnh'" src="../../assets/img/cnh.jpg" />
          <div v-if="modal.pendency.subtipo_arquivo == 'cnh'">
            A foto da CNH deverá estar aberta, mostrando frente e verso.
          </div>
          <img v-if="modal.pendency.subtipo_arquivo == 'rg'" src="../../assets/img/rg.jpg" />
          <div v-if="modal.pendency.subtipo_arquivo == 'rg'">
            A foto enviada, deverá conter frente e verso do documento. Caso o documento
            esteja lacrado, deverá tirar uma foto de cada lado e junta-las com algum
            software.
          </div>
        </template>
      </div>
    </div>
    <div v-if="!modal.pendency ||
      (modal.pendency && !modal.pendency.subtipos_arquivo) ||
      (modal.pendency &&
        modal.pendency.subtipos_arquivo &&
        modal.pendency.subtipo_arquivo)
    ">
      <div class="grid-12 column">
        <div class="file row align-center grid-12">
          <div class="field grid-8 grid-6-s">
            <div class="filler row align-center" :class="barcolor" :style="`width: ${file.percentLoaded}%`">
              {{ file.name || file.percentLoaded + "%" }}
            </div>
          </div>
          <button class="grid-4 grid-6-s" onclick="document.getElementById('attach').click()">
            SELECIONAR ARQUIVOS
          </button>
        </div>

        <input id="attach" type="file" ref="files" @change="loadFile" class="hide" />
        <div class="type">
          Tipos de arquivos permitidos:
          <b>JPG, JPEG, PNG e PDF</b>
          <br />Tamanho máximo do arquivo:
          <b>10MB</b>
        </div>
        <div class="divider"></div>

        <div class="container">
          <embed v-if="midia" :src="midia" type="application/pdf" />
        </div>

        <div class="divider"></div>
        <div class="column grid-12 align-center">
          <p v-if="error" class="text-red text-center">
            <br /><br /><b>Erro ao tentar enviar arquivo:</b><br />{{ error }}
          </p>
          <Button layout="green-go" @click="submitFiles()" :loader="loader">ENVIAR</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button";

export default {
  name: "Files",
  props: {
    modal: Object,
  },
  components: {
    Button,
  },
  data() {
    return {
      file: { name: "", percentLoaded: 0 },
      files: "",
      loader: false,
      allow: false,
      midia: "",
      error: "",
      barcolor: "green",
    };
  },

  methods: {
    ...mapActions("user", ["POST_NF", "PUT_NF", "SET_FILES"]),
    updateSub() {
      this.$forceUpdate();
    },
    loadFile(f) {
      this.barcolor = "green";
      this.midia = "";
      this.allow = false;
      this.files = this.$refs.files.files;
      this.file = { name: "", percentLoaded: 0 };
      var file = f.target.files || f.dataTransfer.files;
      file = file[0];
      if (file) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onprogress = (e) => {
          if (e.lengthComputable)
            this.file.percentLoaded = Math.round((e.loaded / e.total) * 100);
        };

        reader.onload = (e) => {
          if (file.type.match("image/jpeg|image/png|image/jpg|application/pdf")) {
            this.allow = true;
            this.midia = e.target.result;
          } else {
            this.file.name = "TIPO DE ARQUIVO NÃO PERMITIDO";
            this.barcolor = "red";
          }
        };
      }
    },
    submitFiles() {
      if (this.allow) {
        this.loader = true;
        var formData = new FormData();
        formData.append("arquivo", this.files[0]);

        // PENDENCIES
        if (this.modal.pendency) {
          formData.append("tipo_arquivo", this.modal.pendency.tipo_arquivo);

          formData.append("subtipo_arquivo", this.modal.pendency.subtipo_arquivo || "");

          formData.append("data_emissao_arquivo", new Date().toISOString().slice(0, 10));
          this.SET_FILES(formData).then((r) => {
            if (r && r.status && r.status == 201) {
              if (this.modal.cb) this.modal.cb(this.midia);
            } else this.error = r.response.data.msg || r.data.msg;
            this.loader = false;
          });
          return;
        }

        // NF
        if (this.modal.erro)
          this.PUT_NF({
            dt_previsao_pagamento: this.modal.dt_previsao_pagamento,
            arquivo: formData,
            ciclo_semanal: this.modal.tipo_ciclo == "Semanal" ? true : false,
          })
            .then(() => {
              this.modal.show = false;
              this.modal.callback();
              this.loader = false;
            })
            .catch(() => {
              this.modal.show = false;
              this.modal.callback();
              this.loader = false;
            });
        else
          this.POST_NF({
            dt_previsao_pagamento: this.modal.dt_previsao_pagamento,
            arquivo: formData,
            ciclo_semanal: this.modal.tipo_ciclo == "Semanal" ? true : false,
          })
            .then(() => {
              this.modal.show = false;
              this.modal.callback();
              this.loader = false;
            })
            .catch(() => {
              this.modal.show = false;
              this.modal.callback();
              this.loader = false;
            });
      }
    },
  },
  mounted() {
    if (this.modal.trigger) document.getElementById("attach").click();
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.files {
  padding: 10px 30px;
  padding-top: 25px;
  padding-bottom: 25px;
  color: $gray-6;
  font-size: 15px;

  @media (min-width: $small) {
    width: 600px;
  }

  .button-green-go {
    margin-top: 40px;
  }

  .ilustration {
    padding: 30px;
    color: $red-1;
    font-weight: bold;
    font-size: 19px;

    @media (max-width: $small) {
      padding: 0px;
      margin-top: 21px;
    }

    img {
      width: 300px;
      margin-right: 30px;

      @media (max-width: $small) {
        width: 100%;
        margin-left: 0px;
        margin-top: 12px;
      }
    }
  }

  .container {
    max-height: 400px;
    overflow: auto;
  }

  embed {
    width: 100%;
  }

  strong {
    font-weight: 500;
    color: $font-color;
  }

  .type {
    margin-top: 25px;
    margin-bottom: 35px;

    @media (max-width: $small) {
      font-size: 0.7rem;
    }
  }

  .file {
    margin-top: 25px;

    .filler {
      &.green {
        background: $green-2;
      }

      &.red {
        background: $red;
      }

      height: 40px;
      padding-left: 10px;
      color: $white;
      font-weight: bold;

      @media (max-width: $small) {
        font-size: 0.7rem;
      }
    }

    .field {
      height: 40px;
      background: #f2f2f2 0% 0% no-repeat padding-box;
      border: 1px solid #dbdbdb;
      border-radius: 5px 0px 0px 5px;
      opacity: 1;
    }

    button {
      height: 42px;
      background: $supporter-1;
      border-radius: 0px 5px 5px 0px;
      opacity: 1;
      color: $white;
      font-weight: bold;
    }
  }

  .status {
    @media (max-width: $small) {
      margin-top: 12px;
    }
  }
}
</style>
